import { useEffect, useState } from "react";
import {
  getQuestionData,
  submitAnswerDataFe } from
"../../services/epic/bloodDonation";
import QuestionHeaders from "./QuestionHeaders";
import { configureFirstIframe } from "../../utils/util";
import { Loader } from "../../common/Loader";

const QuestionStep2 = ({
  setRequestStep,
  mobileNum,
  setSubmittedAnswerDataRequest,
  requestStep,
  loading,
  setLoading,
  submittedAnswerData,
  setSubmittedAnswerData,
  handleCancel,
  userName,
  translationMap
}) => {
  const [generalQuestion, setGeneralQuestion] = useState([]);
  const [isAllAnswered, setIsAllAnswered] = useState(false);

  useEffect(() => {
    const questionRequestBody = { categoryIndex: 1 };
    getQuestionData(questionRequestBody).then((result) => {
      //console.log("questions in step 1", result?.data);
      setGeneralQuestion(result.data);
    });
    setLoading(false);
    configureFirstIframe(500, 750);
    //setIsLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    checkAllAnswered();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submittedAnswerData, generalQuestion]);

  const checkAllAnswered = () => {
    if (generalQuestion?.length === 0 || submittedAnswerData?.generalQuestions?.length === 0) {
      return;
    }
    const allAnswered = generalQuestion.every((question) => {
      // console.log("question index", question?.questionIndex);
      const answer = submittedAnswerData?.generalQuestions?.find(
        (item) => item.QUESTION_INDEX === question.questionIndex
      );
      return answer && answer.ANSWER !== "";
    });
    // console.log("all answered value", allAnswered);
    setIsAllAnswered(allAnswered);
  };

  const handleChange = (
  e,
  stepKey,
  categoryIndex,
  questionIndex,
  categoryTitle,
  questionTitle) =>
  {
    const newAnswer = e.target.value;
    const currentStepData = submittedAnswerData[stepKey] || [];
    const questionExists = currentStepData.some(
      (item) => item.QUESTION_INDEX === questionIndex
    );
    const updatedStepData = questionExists ?
    currentStepData.map((item) =>
    item.QUESTION_INDEX === questionIndex ?
    { ...item, ANSWER: newAnswer } :
    item
    ) :
    [
    ...currentStepData,
    {
      CATEGORY_INDEX: categoryIndex,
      QUESTION_INDEX: questionIndex,
      CATEGORY_TITLE: categoryTitle,
      QUESTION_TITLE: questionTitle,
      ANSWER: newAnswer,
      GENDER: 0
    }];

    setSubmittedAnswerData({
      ...submittedAnswerData,
      [stepKey]: updatedStepData
    });
  };


  const submitAnswer = () => {
    const answerQrCodeValue = Object.values(submittedAnswerData?.generalQuestions)
    .map((item) => item.ANSWER)
    .join("");
    const version = "V1.0";
    const answerDataRequestBody = {
      generalQuestions: submittedAnswerData?.generalQuestions,
      languageId: "en_US",
      liferayUserName: userName,
      mobileNumber: mobileNum,
      qrCodeValue: answerQrCodeValue,
      version: version
    };
    //console.log("answer data request body 2", answerDataRequestBody);
    submitAnswerDataFe(answerDataRequestBody).then((result) => {
      if (result) {
        setRequestStep(4);
        window.parent.scrollTo(0, 0);
        //  setAnswerJsonData(result);
        setSubmittedAnswerDataRequest(answerDataRequestBody);
      }
    });
    setRequestStep(4);
  };
  if (loading) {
    return <Loader />;
  }

  return (
    <>
        <section
        className="w-100 clearfix BloodDonationMainSection"
        id="CoverPlanActive">
        
          <div className="container customContainer">
            <QuestionHeaders
            setRequestStep={setRequestStep}
            currentStep={requestStep - 1}
            translationMap={translationMap} />
          
            <div className="cover_inner_wrapper cover_inner_wrapper2">
              <div className="cover_main_box1">
                <div className="Optimized_Main_Wrap_Box Optimized_Main_Wrap_Box2">
                  <div className="optimized_welcome_box">
                    <div className="donation_form_title_box">
                    <p className="Gray_Title">
                        {translationMap?.beforeProceedingToBloodDonation}
                      </p>
                      <p className="Gray_Title">
                        {translationMap?.generalQuestions}:&nbsp;
                      </p>
                    </div>

                    {generalQuestion &&
                  generalQuestion?.map((questionData) =>
                  <div
                    className="General_Question_Box"
                    key={questionData.id}>
                    
                          <h6 className="question_txt">
                            {questionData?.questionIndex} -{" "}
                            {questionData?.questionTitle}
                          </h6>
                          <div className="article-question">
                            <div className="radio-inline">
                              <input
                          onClick={(e) =>
                          handleChange(
                            e,
                            "generalQuestions",
                            questionData.categoryIndex,
                            questionData.questionIndex,
                            questionData.categoryTitle,
                            questionData.questionTitle
                          )
                          }
                          className="radio-inline-input"
                          type="radio"
                          name={`${questionData.questionIndex}`}
                          id={`Y_${questionData.questionIndex}`}
                          value="Y"
                          checked={
                          submittedAnswerData?.generalQuestions?.find(
                            (answer) => answer.QUESTION_INDEX === questionData?.questionIndex
                          )?.ANSWER === "Y"
                          } />
                        
                              <label
                          className="radio-inline-label"
                          htmlFor={`Y_${questionData.questionIndex}`}>
                          
                                {translationMap?.yes}
                              </label>
                            </div>
                            <div className="radio-inline">
                              <input
                          onClick={(e) =>
                          handleChange(
                            e,
                            "generalQuestions",
                            questionData.categoryIndex,
                            questionData.questionIndex,
                            questionData.categoryTitle,
                            questionData.questionTitle
                          )
                          }
                          className="radio-inline-input"
                          type="radio"
                          name={`${questionData.questionIndex}`}
                          id={`N_${questionData.questionIndex}`}
                          value="N"
                          checked={
                          submittedAnswerData?.generalQuestions?.find(
                            (answer) => answer.QUESTION_INDEX === questionData?.questionIndex
                          )?.ANSWER === "N"
                          } />
                        
                              <label
                          className="radio-inline-label"
                          htmlFor={`N_${questionData.questionIndex}`}>
                          
                                {translationMap?.no}
                              </label>
                            </div>
                            {questionData.gender === 1 &&
                      <div className="radio-inline">
                                <input
                          onClick={(e) =>
                          handleChange(
                            e,
                            "generalQuestions",
                            questionData.categoryIndex,
                            questionData.questionIndex,
                            questionData.categoryTitle,
                            questionData.questionTitle
                          )
                          }
                          className="radio-inline-input"
                          type="radio"
                          name={`${questionData.questionIndex}`}
                          id={`M_${questionData.questionIndex}`}
                          value="M"
                          checked={
                          submittedAnswerData?.generalQuestions?.find(
                            (answer) => answer.QUESTION_INDEX === questionData?.questionIndex
                          )?.ANSWER === "M"
                          } />
                        
                                <label
                          className="radio-inline-label"
                          htmlFor={`M_${questionData.questionIndex}`}>
                          
                                  {translationMap?.male || "Male"}
                                </label>
                              </div>
                      }
                          </div>
                        </div>
                  )}

                    <div className="optimized_btn_box optimized_btn_box_mrt">
                      <button
                      onClick={submitAnswer}
                      className={
                      !isAllAnswered ?
                      "disabled_btn_link" :
                      "bluetrans_btn_link"
                      }>
                      
                        {translationMap?.continue || "Continue"}
                      </button>
                      <button
                      onClick={() => {
                        setRequestStep(2);
                        window.parent.scrollTo(0, 0);
                      }}
                      className="bluetrans_btn_link">
                      
                        {translationMap?.back}
                      </button>
                      <button
                      onClick={handleCancel}
                      className="Orangetrans_btn_link">
                      
                        {translationMap?.cancel}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="cover_main_box2"></div>
            </div>
          </div>
        </section>
    </>);

};

export default QuestionStep2;